// Mock data for Osyla store clone

export const products = [
  {
    id: 1,
    name: "Toile de store Ardoise Dickson Orchestra 8203",
    brand: "Dickson",
    collection: "Orchestra Solids",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1620121692029-d088224ddc74?w=400&h=400&fit=crop",
    color: "Gris",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-ardoise-dickson-8203"
  },
  {
    id: 2,
    name: "Toile de store Carbone Dickson orchestra u171",
    brand: "Dickson",
    collection: "Orchestra Solids",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=400&h=400&fit=crop",
    color: "Noir",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-carbone-dickson-u171"
  },
  {
    id: 3,
    name: "Toile de store Davos Dickson Orchestra 6172",
    brand: "Dickson",
    collection: "Orchestra",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?w=400&h=400&fit=crop",
    color: "Beige",
    pattern: "Rayures classiques",
    grammage: "300g",
    slug: "toile-davos-dickson-6172"
  },
  {
    id: 4,
    name: "Toile de store BS gris Dickson orchestra 8907",
    brand: "Dickson",
    collection: "Orchestra",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1578632767115-351597cf2477?w=400&h=400&fit=crop",
    color: "Gris",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-bs-gris-dickson-8907"
  },
  {
    id: 5,
    name: "Toile de store Ascot Dickson Orchestra 0842",
    brand: "Dickson",
    collection: "Orchestra",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=400&fit=crop",
    color: "Beige",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-ascot-dickson-0842"
  },
  {
    id: 6,
    name: "Toile de store Mandarine Sauleda Sensation 2142",
    brand: "Sauleda",
    collection: "Sensation",
    price: 35.09,
    image: "https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=400&h=400&fit=crop",
    color: "Orange",
    pattern: "Unis",
    grammage: "300g",
    slug: "toile-mandarine-sauleda-2142"
  },
  {
    id: 7,
    name: "Toile de store Gris N Sauleda Sensation 2103",
    brand: "Sauleda",
    collection: "Sensation",
    price: 35.09,
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=400&h=400&fit=crop",
    color: "Gris",
    pattern: "Unis",
    grammage: "300g",
    slug: "toile-gris-sauleda-2103"
  },
  {
    id: 8,
    name: "Toile de store Bordeaux Dickson Orchestra 8206",
    brand: "Dickson",
    collection: "Orchestra Solids",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1557683311-eac922347aa1?w=400&h=400&fit=crop",
    color: "Rouge",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-bordeaux-dickson-8206"
  },
  {
    id: 9,
    name: "Toile de store Beige Dickson Orchestra 8902",
    brand: "Dickson",
    collection: "Orchestra Solids",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?w=400&h=400&fit=crop",
    color: "Beige",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-beige-dickson-8902"
  },
  {
    id: 10,
    name: "Toile de store Caramel Sauleda Sensation 2022",
    brand: "Sauleda",
    collection: "Sensation",
    price: 35.09,
    image: "https://images.unsplash.com/photo-1557682268-e3955ed5d83f?w=400&h=400&fit=crop",
    color: "Marron",
    pattern: "Unis",
    grammage: "300g",
    slug: "toile-caramel-sauleda-2022"
  },
  {
    id: 11,
    name: "Toile de store Emeraude Dickson orchestra 8544",
    brand: "Dickson",
    collection: "Orchestra",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1557683316-973673baf926?w=400&h=400&fit=crop",
    color: "Vert",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-emeraude-dickson-8544"
  },
  {
    id: 12,
    name: "Toile de store Jaune Dickson Orchestra 6316",
    brand: "Dickson",
    collection: "Orchestra Solids",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1557683304-673a23048d34?w=400&h=400&fit=crop",
    color: "Jaune",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-jaune-dickson-6316"
  },
  {
    id: 13,
    name: "Toile de store BS Bleu Dickson Orchestra 8910",
    brand: "Dickson",
    collection: "Orchestra",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1557683325-3ba8f0df67d8?w=400&h=400&fit=crop",
    color: "Bleu",
    pattern: "Unis",
    grammage: "290g",
    slug: "toile-bleu-dickson-8910"
  },
  {
    id: 14,
    name: "Toile de store Champagne Sauleda Sensation 2826",
    brand: "Sauleda",
    collection: "Sensation",
    price: 35.09,
    image: "https://images.unsplash.com/photo-1557683311-8673a23048d3?w=400&h=400&fit=crop",
    color: "Beige",
    pattern: "Unis",
    grammage: "300g",
    slug: "toile-champagne-sauleda-2826"
  },
  {
    id: 15,
    name: "Toile de store New-York Sauleda Sensation 2174",
    brand: "Sauleda",
    collection: "Sensation",
    price: 35.09,
    image: "https://images.unsplash.com/photo-1557683316-973673baf926?w=400&h=400&fit=crop",
    color: "Bleu",
    pattern: "Rayures classiques",
    grammage: "300g",
    slug: "toile-newyork-sauleda-2174"
  },
  {
    id: 16,
    name: "Toile de store Windsor Dickson Orchestra 6292",
    brand: "Dickson",
    collection: "Orchestra",
    price: 35.54,
    image: "https://images.unsplash.com/photo-1557683304-673a23048d34?w=400&h=400&fit=crop",
    color: "Gris",
    pattern: "Rayures fantaisies",
    grammage: "290g",
    slug: "toile-windsor-dickson-6292"
  }
];

export const brands = [
  { name: "Dickson", count: 264 },
  { name: "Sattler", count: 247 },
  { name: "Para", count: 542 },
  { name: "Recascens", count: 1 },
  { name: "Giovanardi", count: 176 },
  { name: "Latim", count: 296 },
  { name: "Sauleda", count: 287 },
  { name: "Serge Ferrari", count: 87 }
];

export const qualities = [
  { name: "Anti-UV et anti chaleur", count: 21 },
  { name: "Étanche", count: 29 },
  { name: "Micro-perforée", count: 42 },
  { name: "Très résistante", count: 21 },
  { name: "Imperméabilisé", count: 428 }
];

export const patterns = [
  { name: "Unis", count: 1077 },
  { name: "Rayures classiques", count: 160 },
  { name: "Motifs", count: 51 },
  { name: "Rayures fantaisies", count: 628 }
];

export const colors = [
  { name: "Blanc", count: 76, hex: "#FFFFFF" },
  { name: "Noir", count: 43, hex: "#000000" },
  { name: "Orange", count: 103, hex: "#FF8C42" },
  { name: "Rose", count: 32, hex: "#FFB6C1" },
  { name: "Violet", count: 25, hex: "#9370DB" },
  { name: "Beige", count: 157, hex: "#F5DEB3" },
  { name: "Marron", count: 217, hex: "#8B4513" },
  { name: "Gris", count: 342, hex: "#808080" },
  { name: "Vert", count: 249, hex: "#228B22" },
  { name: "Jaune", count: 243, hex: "#FFD700" },
  { name: "Rouge", count: 181, hex: "#DC143C" },
  { name: "Bleu", count: 219, hex: "#4169E1" }
];

export const navCategories = [
  { name: "Toile De Store", hasDropdown: false },
  { name: "Toile de Store Droit", hasDropdown: false },
  { name: "Toile de Store à Double Pente", hasDropdown: false },
  { name: "Lambrequin Seul", hasDropdown: false },
  { name: "Toile De Pergola", hasDropdown: false },
  { name: "Brise-Vue De Balcon", hasDropdown: false },
  { name: "Toile de Store au Metre", hasDropdown: false }
];

export const brandDescriptions = [
  {
    name: "Dickson",
    description: "Mondialement connu pour la qualité et la durabilité de ces produits. Référence Française des tissus indoor & outdoor."
  },
  {
    name: "Para",
    description: "Le Groupe Italien Parà est une société familiale créé en 1921. Depuis plus de 3 générations, Parà produit des tissus esthétiques et de haute qualité."
  },
  {
    name: "Sauleda",
    description: "Fondée en 1897 par Victoriano Sauleda, l'entreprise d'origine Catalane est basée à Barcelone en Espagne."
  },
  {
    name: "Serge Ferrari",
    description: "Le groupe Serge Ferrari est une entreprise crée en 1973. Considéré comme la rolls royce de la toile."
  },
  {
    name: "Giovanardi",
    description: "L'entreprise Giofex anciennement Giovanardi est une société italienne fondée en 1963."
  },
  {
    name: "Latim",
    description: "Le Groupe Latim est une entreprise familiale française, crée en 1931."
  },
  {
    name: "Recasens",
    description: "Créé depuis 1886, Recasens est une entreprise familiale espagnole basée à Barcelone."
  },
  {
    name: "Sattler",
    description: "Le Groupe Autrichien Sattler est une société familiale, d'envergure mondiale, créé en 1875."
  }
];